export function hasProps<K extends PropertyKey>(obj: unknown, keys: K[]): obj is Record<K, unknown> {
    return keys.every((key) => hasProp(obj, key));
}

// https://stackoverflow.com/a/72625159
export function hasProp<K extends PropertyKey>(obj: unknown, key: K): obj is Record<K, unknown> {
    return key != null && obj != null && typeof obj === 'object' && key in obj;
}
